import React from 'react';

function IndividualIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_13435_9970)">
        <path
          // eslint-disable-next-line max-len
          d="M23.4792 7.99075C23.4792 10.0804 22.7197 11.8892 21.2214 13.3678C19.7231 14.8461 17.8896 15.5955 15.7717 15.5955H15.7681C13.6528 15.5948 11.8206 14.8454 10.3223 13.3678C8.82373 11.8892 8.06445 10.0804 8.06445 7.99075C8.06445 5.90179 8.82373 4.09274 10.3223 2.61443C11.8198 1.1366 13.6521 0.387441 15.7681 0.386719H15.7717C17.8889 0.386719 19.7224 1.13611 21.2214 2.61443C22.7197 4.09274 23.4792 5.90179 23.4792 7.99075Z"
          fill="#FBBA86"
        />
        <path
          // eslint-disable-next-line max-len
          d="M29.323 26.5296C29.323 28.1782 28.7915 29.5129 27.7446 30.496C26.71 31.4675 25.3416 31.9596 23.6777 31.9596H8.26953C6.60571 31.9596 5.2373 31.4675 4.20337 30.496C3.15576 29.5122 2.625 28.1777 2.625 26.5296C2.625 25.8956 2.64624 25.2683 2.68872 24.6651C2.73193 24.0485 2.81934 23.3773 2.94824 22.6694C3.07812 21.9556 3.24512 21.2809 3.44507 20.6643C3.65259 20.0259 3.93335 19.3962 4.28076 18.7931C4.6416 18.167 5.06543 17.6216 5.54053 17.1726C6.03857 16.7026 6.64746 16.3252 7.35132 16.0501C8.05273 15.7764 8.83032 15.6377 9.66235 15.6377C9.98877 15.6377 10.3049 15.7695 10.9143 16.1611C11.2957 16.4066 11.7351 16.686 12.2202 16.992C12.6392 17.2555 13.2065 17.5026 13.908 17.7259C14.5244 17.9227 15.1501 18.0326 15.7683 18.0516C15.8364 18.054 15.9045 18.0552 15.9727 18.0552C16.6592 18.0552 17.3535 17.9442 18.0381 17.7259C18.7395 17.5026 19.3076 17.2555 19.7263 16.992C20.2166 16.6829 20.656 16.4037 21.0317 16.1619C21.6416 15.7695 21.9573 15.6377 22.2844 15.6377C23.1157 15.6377 23.8933 15.7764 24.5952 16.0501C25.2991 16.3252 25.908 16.7034 26.4055 17.1726C26.8813 17.6216 27.3052 18.167 27.6658 18.7931C28.0134 19.3967 28.2947 20.0259 28.5015 20.6635C28.7017 21.2809 28.8691 21.9556 28.999 22.6699C29.1272 23.3785 29.2148 24.0497 29.2578 24.6646C29.301 25.2659 29.3223 25.8932 29.323 26.5296Z"
          fill="#41A5EE"
        />
      </g>
      <defs>
        <clipPath id="clip0_13435_9970">
          <rect
            width="32"
            height="31.5733"
            fill="white"
            transform="translate(0 0.386719)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IndividualIcon;
